module.exports = __webpack_public_path__ + "static/inceptia-29b8d9f93528a57ad3dcfc38790b1b89.png";